// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { SubBrandFragment } from '../../../../modules/admin/branding/graphql/Branding.generated';
import { TenantPresentationConfiguration_SubBrandDisclaimerConfigurationFragment } from '../../../../modules/presentation/graphql/TenantPresentationConfiguration.generated';
import { gql } from '@apollo/client';
import { SubBrandFragmentDoc } from '../../../../modules/admin/branding/graphql/Branding.generated';
import { TenantPresentationConfiguration_SubBrandDisclaimerConfigurationFragmentDoc } from '../../../../modules/presentation/graphql/TenantPresentationConfiguration.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateLegalDisclaimersMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateTenantDisclaimerConfigurationInput;
}>;


export type UpdateLegalDisclaimersMutation = { __typename?: 'Mutation', updateTenantDisclaimerConfiguration: { __typename?: 'TenantDisclaimerConfiguration', id: string } };

export type UpdateSubBrandLegalDisclaimersMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateSubBrandDisclaimerConfigurationInput;
}>;


export type UpdateSubBrandLegalDisclaimersMutation = { __typename?: 'Mutation', updateSubBrandDisclaimerConfiguration: { __typename?: 'SubBrandDisclaimerConfiguration', id: string } };

export type CreateSubBrandLegalDisclaimersMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateSubBrandDisclaimerConfigurationInput;
}>;


export type CreateSubBrandLegalDisclaimersMutation = { __typename?: 'Mutation', createSubBrandDisclaimerConfiguration: { __typename?: 'SubBrandDisclaimerConfiguration', id: string } };

export type CreateOrganizationLegalDisclaimersMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateOrganizationDisclaimerConfigurationInput;
}>;


export type CreateOrganizationLegalDisclaimersMutation = { __typename?: 'Mutation', createOrganizationDisclaimerConfiguration: { __typename?: 'OrganizationDisclaimerConfiguration', id: string } };

export type UpdateOrganizationLegalDisclaimersMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateOrganizationDisclaimerConfigurationInput;
}>;


export type UpdateOrganizationLegalDisclaimersMutation = { __typename?: 'Mutation', updateOrganizationDisclaimerConfiguration: { __typename?: 'OrganizationDisclaimerConfiguration', id: string } };

export type LegalDisclaimersForm_TenantDisclaimerConfigurationFragment = { __typename?: 'TenantDisclaimerConfiguration', id: string, presentationCoverDisclaimerTitle?: string | null, presentationCoverDisclaimerBody?: string | null, presentationFooterDisclaimerTitle?: string | null, presentationFooterDisclaimerBody?: string | null, presentationStandaloneDisclaimerTitle?: string | null, presentationStandaloneDisclaimerBody?: string | null, includeLuminaryDisclaimer: boolean };

export type LegalDisclaimersForm_OrganizationDisclaimerConfigurationFragment = { __typename?: 'OrganizationDisclaimerConfiguration', id: string, presentationCoverDisclaimerTitle?: string | null, presentationCoverDisclaimerBody?: string | null, presentationFooterDisclaimerTitle?: string | null, presentationFooterDisclaimerBody?: string | null, presentationStandaloneDisclaimerTitle?: string | null, presentationStandaloneDisclaimerBody?: string | null, includeLuminaryDisclaimer: boolean };

export type LegalDisclaimersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LegalDisclaimersQuery = { __typename?: 'Query', organizationDisclaimerConfiguration?: (
    { __typename?: 'OrganizationDisclaimerConfiguration' }
    & LegalDisclaimersForm_OrganizationDisclaimerConfigurationFragment
  ) | null, tenantInformation: { __typename?: 'TenantInformation', id: string, disclosuresConfiguration?: (
      { __typename?: 'TenantDisclaimerConfiguration' }
      & LegalDisclaimersForm_TenantDisclaimerConfigurationFragment
    ) | null }, subBrands: { __typename?: 'SubBrandConnection', edges?: Array<{ __typename?: 'SubBrandEdge', node?: (
        { __typename?: 'SubBrand', id: string, disclaimerConfiguration?: (
          { __typename?: 'SubBrandDisclaimerConfiguration' }
          & TenantPresentationConfiguration_SubBrandDisclaimerConfigurationFragment
        ) | null }
        & SubBrandFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    LegalDisclaimers: 'LegalDisclaimers' as const
  },
  Mutation: {
    UpdateLegalDisclaimers: 'UpdateLegalDisclaimers' as const,
    UpdateSubBrandLegalDisclaimers: 'UpdateSubBrandLegalDisclaimers' as const,
    CreateSubBrandLegalDisclaimers: 'CreateSubBrandLegalDisclaimers' as const,
    CreateOrganizationLegalDisclaimers: 'CreateOrganizationLegalDisclaimers' as const,
    UpdateOrganizationLegalDisclaimers: 'UpdateOrganizationLegalDisclaimers' as const
  },
  Fragment: {
    LegalDisclaimersForm_TenantDisclaimerConfiguration: 'LegalDisclaimersForm_TenantDisclaimerConfiguration' as const,
    LegalDisclaimersForm_OrganizationDisclaimerConfiguration: 'LegalDisclaimersForm_OrganizationDisclaimerConfiguration' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const LegalDisclaimersForm_TenantDisclaimerConfigurationFragmentDoc = gql`
    fragment LegalDisclaimersForm_TenantDisclaimerConfiguration on TenantDisclaimerConfiguration {
  id
  presentationCoverDisclaimerTitle
  presentationCoverDisclaimerBody
  presentationFooterDisclaimerTitle
  presentationFooterDisclaimerBody
  presentationStandaloneDisclaimerTitle
  presentationStandaloneDisclaimerBody
  includeLuminaryDisclaimer
}
    `;
export const LegalDisclaimersForm_OrganizationDisclaimerConfigurationFragmentDoc = gql`
    fragment LegalDisclaimersForm_OrganizationDisclaimerConfiguration on OrganizationDisclaimerConfiguration {
  id
  presentationCoverDisclaimerTitle
  presentationCoverDisclaimerBody
  presentationFooterDisclaimerTitle
  presentationFooterDisclaimerBody
  presentationStandaloneDisclaimerTitle
  presentationStandaloneDisclaimerBody
  includeLuminaryDisclaimer
}
    `;
export const UpdateLegalDisclaimersDocument = gql`
    mutation UpdateLegalDisclaimers($input: AugmentedUpdateTenantDisclaimerConfigurationInput!) {
  updateTenantDisclaimerConfiguration(input: $input) {
    id
  }
}
    `;
export type UpdateLegalDisclaimersMutationFn = Apollo.MutationFunction<UpdateLegalDisclaimersMutation, UpdateLegalDisclaimersMutationVariables>;

/**
 * __useUpdateLegalDisclaimersMutation__
 *
 * To run a mutation, you first call `useUpdateLegalDisclaimersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegalDisclaimersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegalDisclaimersMutation, { data, loading, error }] = useUpdateLegalDisclaimersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLegalDisclaimersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLegalDisclaimersMutation, UpdateLegalDisclaimersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLegalDisclaimersMutation, UpdateLegalDisclaimersMutationVariables>(UpdateLegalDisclaimersDocument, options);
      }
export type UpdateLegalDisclaimersMutationHookResult = ReturnType<typeof useUpdateLegalDisclaimersMutation>;
export type UpdateLegalDisclaimersMutationResult = Apollo.MutationResult<UpdateLegalDisclaimersMutation>;
export type UpdateLegalDisclaimersMutationOptions = Apollo.BaseMutationOptions<UpdateLegalDisclaimersMutation, UpdateLegalDisclaimersMutationVariables>;
export const UpdateSubBrandLegalDisclaimersDocument = gql`
    mutation UpdateSubBrandLegalDisclaimers($input: AugmentedUpdateSubBrandDisclaimerConfigurationInput!) {
  updateSubBrandDisclaimerConfiguration(input: $input) {
    id
  }
}
    `;
export type UpdateSubBrandLegalDisclaimersMutationFn = Apollo.MutationFunction<UpdateSubBrandLegalDisclaimersMutation, UpdateSubBrandLegalDisclaimersMutationVariables>;

/**
 * __useUpdateSubBrandLegalDisclaimersMutation__
 *
 * To run a mutation, you first call `useUpdateSubBrandLegalDisclaimersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubBrandLegalDisclaimersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubBrandLegalDisclaimersMutation, { data, loading, error }] = useUpdateSubBrandLegalDisclaimersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubBrandLegalDisclaimersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubBrandLegalDisclaimersMutation, UpdateSubBrandLegalDisclaimersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubBrandLegalDisclaimersMutation, UpdateSubBrandLegalDisclaimersMutationVariables>(UpdateSubBrandLegalDisclaimersDocument, options);
      }
export type UpdateSubBrandLegalDisclaimersMutationHookResult = ReturnType<typeof useUpdateSubBrandLegalDisclaimersMutation>;
export type UpdateSubBrandLegalDisclaimersMutationResult = Apollo.MutationResult<UpdateSubBrandLegalDisclaimersMutation>;
export type UpdateSubBrandLegalDisclaimersMutationOptions = Apollo.BaseMutationOptions<UpdateSubBrandLegalDisclaimersMutation, UpdateSubBrandLegalDisclaimersMutationVariables>;
export const CreateSubBrandLegalDisclaimersDocument = gql`
    mutation CreateSubBrandLegalDisclaimers($input: AugmentedCreateSubBrandDisclaimerConfigurationInput!) {
  createSubBrandDisclaimerConfiguration(input: $input) {
    id
  }
}
    `;
export type CreateSubBrandLegalDisclaimersMutationFn = Apollo.MutationFunction<CreateSubBrandLegalDisclaimersMutation, CreateSubBrandLegalDisclaimersMutationVariables>;

/**
 * __useCreateSubBrandLegalDisclaimersMutation__
 *
 * To run a mutation, you first call `useCreateSubBrandLegalDisclaimersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubBrandLegalDisclaimersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubBrandLegalDisclaimersMutation, { data, loading, error }] = useCreateSubBrandLegalDisclaimersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubBrandLegalDisclaimersMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubBrandLegalDisclaimersMutation, CreateSubBrandLegalDisclaimersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubBrandLegalDisclaimersMutation, CreateSubBrandLegalDisclaimersMutationVariables>(CreateSubBrandLegalDisclaimersDocument, options);
      }
export type CreateSubBrandLegalDisclaimersMutationHookResult = ReturnType<typeof useCreateSubBrandLegalDisclaimersMutation>;
export type CreateSubBrandLegalDisclaimersMutationResult = Apollo.MutationResult<CreateSubBrandLegalDisclaimersMutation>;
export type CreateSubBrandLegalDisclaimersMutationOptions = Apollo.BaseMutationOptions<CreateSubBrandLegalDisclaimersMutation, CreateSubBrandLegalDisclaimersMutationVariables>;
export const CreateOrganizationLegalDisclaimersDocument = gql`
    mutation CreateOrganizationLegalDisclaimers($input: AugmentedCreateOrganizationDisclaimerConfigurationInput!) {
  createOrganizationDisclaimerConfiguration(input: $input) {
    id
  }
}
    `;
export type CreateOrganizationLegalDisclaimersMutationFn = Apollo.MutationFunction<CreateOrganizationLegalDisclaimersMutation, CreateOrganizationLegalDisclaimersMutationVariables>;

/**
 * __useCreateOrganizationLegalDisclaimersMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationLegalDisclaimersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationLegalDisclaimersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationLegalDisclaimersMutation, { data, loading, error }] = useCreateOrganizationLegalDisclaimersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationLegalDisclaimersMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationLegalDisclaimersMutation, CreateOrganizationLegalDisclaimersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationLegalDisclaimersMutation, CreateOrganizationLegalDisclaimersMutationVariables>(CreateOrganizationLegalDisclaimersDocument, options);
      }
export type CreateOrganizationLegalDisclaimersMutationHookResult = ReturnType<typeof useCreateOrganizationLegalDisclaimersMutation>;
export type CreateOrganizationLegalDisclaimersMutationResult = Apollo.MutationResult<CreateOrganizationLegalDisclaimersMutation>;
export type CreateOrganizationLegalDisclaimersMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationLegalDisclaimersMutation, CreateOrganizationLegalDisclaimersMutationVariables>;
export const UpdateOrganizationLegalDisclaimersDocument = gql`
    mutation UpdateOrganizationLegalDisclaimers($input: AugmentedUpdateOrganizationDisclaimerConfigurationInput!) {
  updateOrganizationDisclaimerConfiguration(input: $input) {
    id
  }
}
    `;
export type UpdateOrganizationLegalDisclaimersMutationFn = Apollo.MutationFunction<UpdateOrganizationLegalDisclaimersMutation, UpdateOrganizationLegalDisclaimersMutationVariables>;

/**
 * __useUpdateOrganizationLegalDisclaimersMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationLegalDisclaimersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationLegalDisclaimersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationLegalDisclaimersMutation, { data, loading, error }] = useUpdateOrganizationLegalDisclaimersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationLegalDisclaimersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationLegalDisclaimersMutation, UpdateOrganizationLegalDisclaimersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationLegalDisclaimersMutation, UpdateOrganizationLegalDisclaimersMutationVariables>(UpdateOrganizationLegalDisclaimersDocument, options);
      }
export type UpdateOrganizationLegalDisclaimersMutationHookResult = ReturnType<typeof useUpdateOrganizationLegalDisclaimersMutation>;
export type UpdateOrganizationLegalDisclaimersMutationResult = Apollo.MutationResult<UpdateOrganizationLegalDisclaimersMutation>;
export type UpdateOrganizationLegalDisclaimersMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationLegalDisclaimersMutation, UpdateOrganizationLegalDisclaimersMutationVariables>;
export const LegalDisclaimersDocument = gql`
    query LegalDisclaimers {
  organizationDisclaimerConfiguration {
    ...LegalDisclaimersForm_OrganizationDisclaimerConfiguration
  }
  tenantInformation {
    id
    disclosuresConfiguration {
      ...LegalDisclaimersForm_TenantDisclaimerConfiguration
    }
  }
  subBrands {
    edges {
      node {
        id
        ...SubBrand
        disclaimerConfiguration {
          ...TenantPresentationConfiguration_SubBrandDisclaimerConfiguration
        }
      }
    }
  }
}
    ${LegalDisclaimersForm_OrganizationDisclaimerConfigurationFragmentDoc}
${LegalDisclaimersForm_TenantDisclaimerConfigurationFragmentDoc}
${SubBrandFragmentDoc}
${TenantPresentationConfiguration_SubBrandDisclaimerConfigurationFragmentDoc}`;

/**
 * __useLegalDisclaimersQuery__
 *
 * To run a query within a React component, call `useLegalDisclaimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalDisclaimersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalDisclaimersQuery({
 *   variables: {
 *   },
 * });
 */
export function useLegalDisclaimersQuery(baseOptions?: Apollo.QueryHookOptions<LegalDisclaimersQuery, LegalDisclaimersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalDisclaimersQuery, LegalDisclaimersQueryVariables>(LegalDisclaimersDocument, withFetchPolicyContext(options));
      }
export function useLegalDisclaimersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalDisclaimersQuery, LegalDisclaimersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalDisclaimersQuery, LegalDisclaimersQueryVariables>(LegalDisclaimersDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useLegalDisclaimersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LegalDisclaimersQuery, LegalDisclaimersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LegalDisclaimersQuery, LegalDisclaimersQueryVariables>(LegalDisclaimersDocument, withFetchPolicyContext(options));
        }
export type LegalDisclaimersQueryHookResult = ReturnType<typeof useLegalDisclaimersQuery>;
export type LegalDisclaimersLazyQueryHookResult = ReturnType<typeof useLegalDisclaimersLazyQuery>;
export type LegalDisclaimersSuspenseQueryHookResult = ReturnType<typeof useLegalDisclaimersSuspenseQuery>;
export type LegalDisclaimersQueryResult = Apollo.QueryResult<LegalDisclaimersQuery, LegalDisclaimersQueryVariables>;